import { Injectable } from '@angular/core';
import { PermissionService } from './permission.service';
import { MenuItem } from '../models/menu-item.model';
import { MENU_ITEMS } from '../config/menu.config';

@Injectable({ providedIn: 'root' })
export class MenuService {
  constructor(private permissionService: PermissionService) {}

  getMenu(): MenuItem[] {
    return this.filterMenu(MENU_ITEMS);
  }

  private filterMenu(items: MenuItem[]): MenuItem[] {
    return items
      .filter((item) => {
        if (!item.permission) {
          return true;
        }
        return this.permissionService.has(item.permission);
      })
      .map((item) => ({
        ...item,
        children: item.children ? this.filterMenu(item.children) : undefined,
      }))
      .filter((item) => {
        return !item.children || item.children.length > 0;
      });
  }
}
